import { useEffect, useState } from 'react';

export interface ClockState {
  now: Date;
}

export function useClock(intervalMs = 1000): ClockState {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);

  return { now };
}
